import type { DpsMiniAppBackendLeaderboardTypeEnum } from "@tradingApp/api/types/DpsMiniAppBackend";

export function leaderboardTableRowNotInRankMessage(
  type: DpsMiniAppBackendLeaderboardTypeEnum,
): string {
  switch (true) {
    case type === "ORDER_WIN_RATE":
      return "Min. 10 Orders/week";
    case type === "ORDER_STREAK":
      return "Min. 5 Orders/week";
    case type === "REFERRAL":
      return "Min. 1 Referral/week";
    default:
      return "No massage found";
  }
}
